var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGift(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1 4H15V7H1zM2 8H15V15H2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#8F929C",
    d: "M14.1 7.561v7.311H2.322v-7.31H1.226v7.874c0 .312.246.564.549.564h12.873c.303 0 .549-.252.549-.564V7.561h-1.098z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#8F929C",
    d: "M15.451 3.15H.55c-.303 0-.549.253-.549.564v3.684c0 .312.246.564.549.564H15.45c.303 0 .549-.252.549-.564V3.714c0-.311-.245-.563-.549-.563zm-.548 3.684H1.097V4.278h13.806v2.556z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#8F929C",
    d: "M8.734 3.578C8.697 3.432 7.792 0 5.15 0 4 0 3.065.961 3.065 2.143c0 1.181.927 2.142 2.066 2.142h3.072c.17 0 .33-.08.435-.22.104-.138.14-.318.096-.487zm-3.602-.42c-.544 0-.97-.446-.97-1.015 0-.55.453-1.015.988-1.015 1.204 0 1.924 1.218 2.27 2.03H5.133z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#8F929C",
    d: "M10.959 0C8.317 0 7.412 3.432 7.375 3.578c-.044.17-.008.35.096.488.104.138.264.22.434.22h3.072c1.14 0 2.067-.962 2.067-2.143C13.044.96 12.108 0 10.959 0zm.018 3.157H8.686c.344-.81 1.062-2.03 2.273-2.03.535 0 .988.465.988 1.016 0 .569-.426 1.014-.97 1.014z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#8F929C",
    d: "M8.454 3.78H7.357v11.54h1.097V3.78z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.aa3d5cad.svg";
export { ForwardRef as ReactComponent };